module.exports = {

    'title_landing_pages': 'キャンペーン',
    'description_landing_pages': 'アヤナリワードではライフスタイルにあわせた魅力あふれるご滞在＆アクティビティパッケージをご用意しています',
    'crumb_home': 'ホーム',
    'crumb_promotion': 'キャンペーン',
}